import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useFeatureFlagState } from '@/services/analytics/use-feature-flag'
import type { FlagKey } from '@/services/analytics/feature-flags'

/**
 * Route-level backstop for a flagged product surface. Nav filtering hides
 * the entry; this is what stops a pasted URL from walking past it.
 *
 * While the flag is still loading it renders nothing rather than
 * redirecting: a redirect would move a legitimate user off their own URL
 * on the one paint where PostHog has not answered yet.
 */
export function SurfaceGate({ flag, children }: { flag: FlagKey; children: ReactNode }) {
  const state = useFeatureFlagState(flag)
  if (state === 'loading') return null
  if (state === 'off') return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
